import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Accueil", href: "#", slug: "accueil" },
  { label: "Prestations", href: "#prestations", slug: "prestations" },
  { label: "Tatouage", href: "#tatouage", slug: "tatouage" },
  { label: "Galerie", href: "#galerie", slug: "galerie" },
  { label: "À propos", href: "#apropos", slug: "apropos" },
  { label: "Avis", href: "#avis", slug: "avis" },
  { label: "Contact", href: "#contact", slug: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    if (href === "#") window.scrollTo({ top: 0, behavior: "smooth" });
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "bg-[var(--brand-bg)]/75 backdrop-blur-xl border-b border-black/5" : "bg-transparent"
    }`}
    >
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-12 py-5" data-testid="main-nav">
        <a href="#" onClick={(e) => go(e, "#")}
           className={`font-display text-2xl tracking-tight transition-colors duration-500 ${scrolled ? "text-[var(--brand-dark)]" : "text-[var(--brand-bg)]"}`}
           data-testid="nav-logo">
          Beauty <span className="italic font-light">by</span> Armina
        </a>
        <div className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a key={l.slug} href={l.href} onClick={(e) => go(e, l.href)}
               className={`text-[11px] uppercase tracking-[0.18em] transition-colors duration-300 hover:text-[var(--brand-accent)] ${scrolled ? "text-[var(--brand-dark)]" : "text-[var(--brand-bg)]/85"}`}
               data-testid={`nav-link-${l.slug}`}>
              {l.label}
            </a>
          ))}
          <a href="#reservation" onClick={(e) => go(e, "#reservation")}
             className={`rounded-full px-6 py-3 text-[11px] uppercase tracking-[0.18em] transition-transform duration-300 hover:scale-[0.96] ${
               scrolled ? "bg-[var(--brand-dark)] text-[var(--brand-bg)]" : "bg-[var(--brand-bg)] text-[var(--brand-dark)]"
             }`}
             data-testid="nav-booking-btn">
            Prendre rendez-vous
          </a>
        </div>
        <button className={`lg:hidden ${scrolled ? "text-[var(--brand-dark)]" : "text-[var(--brand-bg)]"}`} onClick={() => setOpen(!open)}
                data-testid="nav-menu-toggle" aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>
      {open && (
        <div className="lg:hidden bg-[var(--brand-bg)]/95 backdrop-blur-xl border-t border-black/5 px-6 py-8 flex flex-col gap-6" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a key={l.slug} href={l.href} onClick={(e) => go(e, l.href)}
               className="text-sm uppercase tracking-[0.2em] text-[var(--brand-dark)]" data-testid={`nav-mobile-link-${l.slug}`}>
              {l.label}
            </a>
          ))}
          <a href="#reservation" onClick={(e) => go(e, "#reservation")}
             className="rounded-full bg-[var(--brand-dark)] text-[var(--brand-bg)] px-6 py-4 text-xs uppercase tracking-[0.2em] text-center"
             data-testid="nav-mobile-booking-btn">
            Prendre rendez-vous
          </a>
        </div>
      )}
    </motion.header>
  );
}
